import * as Yup from 'yup';
import { pagesText } from '../constants/pagesText';

// RFC 5321 caps a forward path at 254 characters, which is what the API's [MaxLength] uses too.
export const EMAIL_MAX_LENGTH = 254;

export const emailValidation = Yup.string()
  .trim()
  .email('Email must be a valid email address')
  .max(EMAIL_MAX_LENGTH, `Email must be ${EMAIL_MAX_LENGTH} characters or fewer`)
  .required('Email is required');

export const passwordValidation = Yup.string()
  .trim()
  .min(15, pagesText.passwordValidationFields.min)
  .required('Password is required.');
